import React from 'react';

import type { SvgProps } from '../enums';

export const FlagBJ: React.FC<SvgProps> = ({ size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_270_54957"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="12"
    >
      <rect width="16" height="12" fill="white" />
    </mask>
    <g mask="url(#mask0_270_54957)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0H16V12H0V0Z"
        fill="#DD2C2B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0V7H16V0H0Z"
        fill="#FECA00"
      />
      <rect width="7" height="12" fill="#5EAA22" />
    </g>
  </svg>
);
